__turbopack_context__.v({
  "buttons-container": "userAccountContactDetails-module-scss-module__t1g0zG__buttons-container",
  "cancel-button": "userAccountContactDetails-module-scss-module__t1g0zG__cancel-button",
  "edit-icon": "userAccountContactDetails-module-scss-module__t1g0zG__edit-icon",
  "edit-icon-error": "userAccountContactDetails-module-scss-module__t1g0zG__edit-icon-error",
  "form-field": "userAccountContactDetails-module-scss-module__t1g0zG__form-field",
  "icon": "userAccountContactDetails-module-scss-module__t1g0zG__icon",
  "icon-not-verified": "userAccountContactDetails-module-scss-module__t1g0zG__icon-not-verified",
  "icon-verified": "userAccountContactDetails-module-scss-module__t1g0zG__icon-verified",
  "phone-container": "userAccountContactDetails-module-scss-module__t1g0zG__phone-container",
  "phone-input-input": "userAccountContactDetails-module-scss-module__t1g0zG__phone-input-input",
  "phoneinput": "userAccountContactDetails-module-scss-module__t1g0zG__phoneinput",
  "phoneinput-disabled": "userAccountContactDetails-module-scss-module__t1g0zG__phoneinput-disabled",
  "radio-buttons-container": "userAccountContactDetails-module-scss-module__t1g0zG__radio-buttons-container",
  "radio-buttons-padding": "userAccountContactDetails-module-scss-module__t1g0zG__radio-buttons-padding",
  "status": "userAccountContactDetails-module-scss-module__t1g0zG__status",
  "text": "userAccountContactDetails-module-scss-module__t1g0zG__text",
  "text-not-verified": "userAccountContactDetails-module-scss-module__t1g0zG__text-not-verified",
  "text-row": "userAccountContactDetails-module-scss-module__t1g0zG__text-row",
  "text-verified": "userAccountContactDetails-module-scss-module__t1g0zG__text-verified",
  "text-width": "userAccountContactDetails-module-scss-module__t1g0zG__text-width",
});
